<template>
  <div class="mt-3 pb-3 card shadow-sm">
  <p class="card-header float-left">得点推移</p>
    <div id="point-table" class="mt-3 container">
      <div v-for="(set, setIdx) in tableData" :key="setIdx">
        <details>
          <summary>{{ setIdx + Math.max(selected,1)}}ゲーム目</summary>
          <table class="table mb-1 mx-auto table-sm text-secondary table-responsive-xl text-nowrap">
            <tbody>
              <tr v-for="(points, pointsIdx) in set" :key="pointsIdx">
                <td v-for="(point, pointIdx) in points"
                    v-if="pointsIdx == 0" class="no-border" :key="pointIdx">
                  <span class="font-half align-bottom">{{ point }}</span>
                </td>
                <td v-for="(point, pointIdx) in points"
                    v-if="pointsIdx == 1"
                    class="lblue" :key="pointIdx">
                  <span v-if="pointIdx === 0" class="mr-3">{{ point }}</span>
                  <span v-else>{{ point }}</span>
                </td>
                <td v-for="(point, pointIdx) in points"
                    v-if="pointsIdx == 2"
                    class="lgreen" :key="pointIdx">
                  <span v-if="pointIdx === 0" class="mr-3">{{ point }}</span>
                  <span v-else>{{ point }}</span>
                </td>
                <td v-for="(point, pointIdx) in points"
                    v-if="pointsIdx == 3" class="no-border" :key="pointIdx">
                  <span class="font-half align-top">{{ point }}</span>
                </td>
              </tr>
            </tbody>
          </table>
        </details>
      </div>
    </div>
  </div>
</template>

<script>
import func from '@/lib/func';

export default {
  name: 'point-table',
  props: ['points', 'gameInfo', 'selected'],
  computed: {
    tableData() {
      const info = {
        p1: 0,
        p2: 0,
        s1: 0,
        s2: 0,
        sv: 0,
      };
      let table = [[' '], [this.gameInfo.player1Name], [this.gameInfo.player2Name], [' ']];
      let cnt = 0;
      const ret = [];
      for (let i = 0; i < this.points.length; i++) {
        // サーバー権表示の行
        let server = func.getNextServer(info, this.gameInfo.firstGameServer);
        // 偶数ゲーム目のゲームだけでpointsが渡された場合はサーバーを反転させないといけない
        if (this.selected !== 0 && this.selected % 2 === 0) {
          if (server === 1) {
            server = 2;
          } else if (server === 2) {
            server = 1;
          }
        }
        if (server === 1) {
          table[0].push('▼');
          table[3].push(' ');
        } else if (server === 2) {
          table[0].push(' ');
          table[3].push('▲');
        }

        // 得点推移
        if (this.points[i] === 1) {
          info.p1 += 1;
          table[1].push(String(info.p1));
          table[2].push('');
        } else {
          info.p2 += 1;
          table[1].push('');
          table[2].push(String(info.p2));
        }
        ret[cnt] = table;
        // ゲーム終了判定
        if (info.p1 >= 11 || info.p2 >= 11) {
          if ((info.p1 - info.p2) ** 2 >= 4) {
            // 終了していた場合、初期化
            info.p1 = 0;
            info.p2 = 0;
            table = [[' '], [this.gameInfo.player1Name], [this.gameInfo.player2Name], [' ']];
            cnt += 1;
            if (info.s1 > info.s2) {
              info.s1 += 1;
            } else {
              info.s2 += 1;
            }
          }
        }
      }
      return ret;
    },
  },
};
</script>

<style scoped>
.font-half{
    font-size: 50%;
}

.lblue{
    border-color: #537799;
    border-width: 2.5px;
  }

.lgreen{
    border-color: #549983;
    border-width: 2.5px;
}

.no-border{
  border-top:0px;
}
</style>



// WEBPACK FOOTER //
// src/components/molecules/PointTable.vue